const REGION_I18N_KEYS: Record<string, string> = {
  'eu-west-3': 'register.region_eu_west_3',
  'af-south-1': 'register.region_af_south_1',
};

const DEFAULT_REGION_I18N_KEY = 'register.region_eu_west_3';

export function getRegionI18nKey(): string {
  const region = import.meta.env.VITE_COGNITO_REGION as string | undefined;
  return (region && REGION_I18N_KEYS[region]) || DEFAULT_REGION_I18N_KEY;
}
